import { render, staticRenderFns } from "./CardGamesCategory.vue?vue&type=template&id=e33511ca&"
import script from "./CardGamesCategory.vue?vue&type=script&lang=js&"
export * from "./CardGamesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports